<template>
    <div class="map-card card-box">
        <div class="map-card-avatar">
            <img src="@/assets/images/map/default.png">
        </div>
        <div class="map-caption">
            <div class="map-card-toolbar-panel">
                <strong class="map-card-caption-text" :title="item.name">{{ item.name }}</strong>
                <div class="map-card-toolbar">
                    <span class="map-card-toolbar-btn icon-glyphicon-option-horizontal"></span>
                    <ul class="map-drop-down-list" v-show="mapCardMenuShow">
                        <li class="map-drop-down-list-item">地图分享
                        </li>
                        <li class="map-drop-down-list-item" @click="copyAtlas">创建副本
                        </li>
                        <li class="map-drop-down-list-item" @click="openFolderSelect">移动
                        </li>
                        <li class="map-drop-down-list-item" @click="delAtlas"> 删除地图

                        </li>
                    </ul>

                </div>
            </div>
            <p class="map-caption-property">
                <span class="icon-icomoon icon-icomoon-assigning-task" title="协作人数"></span>
                <span class="map-caption-property-value">
                    1&nbsp;人
                </span>
            </p>
            <p class="map-caption-property">
                <span class="icon-icomoon icon-icomoon-personage" title="权限角色"></span>
                <span class="map-caption-property-value">
                    地图管理员
                </span>
            </p>
            <p class="map-caption-property">
                <span class="icon-icomoon icon-icomoon-recording" title="记录数"></span>
                <span class="map-caption-property-value">
                    5图层&nbsp;&nbsp;698记录
                </span>
            </p>
            <p class="map-caption-property">
                <span class="icon-icomoon icon-icomoon-time" title="最近更新时间"></span>
                <span class="map-caption-property-value">
                    {{ item.updateTime }}
                </span>
            </p>
            <a class="map-card-view map-card-btn" title="查看地图" href="#" @click="viewMap">浏览</a>
            <a class="map-card-edit map-card-btn" title="进入编辑" href="#" @click="editMap">编辑</a>
        </div>

        <FolderSelect ref="folderSelect" @confirm="handleMoveMap" />
    </div>

</template>

<script>

import { useRouter } from 'vue-router';
import { delAtlas, moveAtlas, copyAtlas } from '@/api/Common';
import { useMapStore } from '@/stores/mapStore';
import FolderSelect from './FolderSelect.vue';

export default {
    name: 'MapCard',
    components: {
        FolderSelect
    },
    data() {
        return {
            mapCardMenuShow: false,
            router: null,
            mapStore: null,
        }
    },
    props: {
        item: {
            type: Object, // 假设 item 是对象类型，根据实际情况调整
            required: true // 表示该参数是必需的
        }
    },
    mounted() {
        this.router = useRouter();
        this.mapStore = useMapStore();
    },
    methods: {
        editMap() {
            this.mapStore.setSelectAtlas(this.item);

            this.router.push({ path: '/map/editor' });
        },
        viewMap() {
            this.mapStore.setSelectAtlas(this.item);
            this.router.push({ path: '/map/viewer' });
        },
        delAtlas() {
            let that = this;
            delAtlas({ "id": this.item.id }).then(res => {
                alert(res.msg);
                if (res.code == 200) {
                    that.$emit('map-refresh');
                }
            })
        },
        openFolderSelect() {
            this.$refs.folderSelect.open();
        },
        copyAtlas() {
            let that = this;
            copyAtlas({ "atlasId": this.item.id }).then(res => {
                alert(res.msg);
                if (res.code == 200) {
                    that.$emit('map-refresh');
                }
            })
        },
        handleMoveMap(selectedFolder) {
            let that = this;
            moveAtlas({ atlasId: this.item.id, folder: selectedFolder.id }).then(res => {
                if (res.code === 200) {
                    that.$emit('map-refresh');
                }
            });
        }
    }
}

</script>

<style scoped>
.map-card {
    position: relative;
    box-shadow: 0px 1px 6px 2px rgba(0, 0, 0, 0.15);
    border: 1px solid #e6e9eb;
    cursor: pointer;
    color: #333333;
}

.map-card-toolbar {
    float: right;
    position: relative;
}

.map-card-toolbar-btn {
    outline: none;
    font-size: 12px;
    border-radius: 50px 0 0 50px;
    position: relative;
    float: right;
    text-align: center;
    color: #576e8b;
    top: 6px;
    line-height: 24px;
    padding: 0px 5px;
    display: none;
}

.map-card-toolbar:hover .map-drop-down-list {
    display: block !important;
}

.map-card-toolbar-panel {
    height: 36px;
    line-height: 36px;
    padding: 0 12px;
}


.map-card-btn:hover {
    color: #0095ff;
    border-color: #0095ff;
}

.map-card-avatar {
    width: 100%;
    overflow: hidden;
}

.map-card-avatar img {
    width: 100%;
    height: 100%;
}

.map-caption {
    position: absolute;
    height: 36px;
    width: 100%;
    background-color: rgba(229, 229, 234, 0.9);
    overflow: hidden;
    bottom: 0;
    transition: height 0.2s;
    z-index: 1;
    text-align: center;
}



.map-card-btn {
    cursor: pointer;
    width: 94px;
    height: 28px;
    line-height: 28px;
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #f2f2f2;
    color: #929aad;
    display: inline-block;
    text-align: center;
    position: relative;
    font-size: 12px;
    bottom: -8px;
}

.map-card-view {
    left: -12px;
}

.map-card-edit {
    right: -12px;
}

.map-caption-property {
    font-size: 12px;
    margin-top: 2px;
    color: #929aad;
    margin-left: 12px;
    text-align: left;
}

.map-card-caption-text {
    width: 164px;
    font-size: 12px;
    display: inline-block;
    padding-left: 10px;
    padding-right: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 36px;
    line-height: 36px;
    padding: 0 12px;
}

.map-card:hover .map-caption {
    height: 160px;
}

.map-card:hover .map-card-toolbar-btn {
    display: inline-block !important;
}

.map-caption-property-value {
    margin-left: 6px;
    position: relative;
    top: -1px;
}

@media screen and (min-width: 1680px) {
    .map-caption {
        height: 40px;
    }

    .map-card-caption {
        height: 40px;
        line-height: 40px;
    }

    .map-card-toolbar-panel {
        height: 40px;
        line-height: 40px;
        padding: 0 12px;
    }

    .map-card-caption-text {
        width: 220px;
        font-size: 14px;
        display: inline-block;
        height: 40px;
        line-height: 40px;
    }

    .map-card:hover .map-caption {
        height: 220px;
    }

    .map-caption-property {
        margin-top: 6px;
        font-size: 14px;
    }

    .map-card-btn {
        width: 116px;
        height: 36px;
        line-height: 36px;
        bottom: -38px;
    }
}

@media screen and (min-width: 1920px) {
    .map-caption {
        height: 40px;
    }

    .map-card-caption {
        height: 40px;
        line-height: 40px;
    }

    .map-card-toolbar-panel {
        height: 40px;
        line-height: 40px;
        padding: 0 12px;
    }

    .map-card-caption-text {
        width: 264px;
        font-size: 14px;
        display: inline-block;
        height: 40px;
        line-height: 40px;
    }

    .map-card:hover .map-caption {
        height: 220px;
    }

    .map-caption-property {
        margin-top: 8px;
        font-size: 14px;
    }

    .map-card-btn {
        width: 136px;
        height: 36px;
        line-height: 36px;
        bottom: -30px;
    }
}
</style>